import * as React from 'react'

import { styled } from '~/styled'

import { Text } from '../text/Text'
import { SegmentedControlContext } from './SegmentedControlContext'

const StyledText = styled(
  Text,
  {
    base: ['font-body', 'text-text-subtle', 'font-normal'],
    variants: {
      size: {
        sm: ['text-xs', 'leading-[1.6]'],
        md: ['text-sm', 'leading-[1.53]'],
        lg: ['text-md', 'leading-normal']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

export const SegmentedControlDescription = (
  props: Omit<React.ComponentProps<typeof StyledText>, 'size'>
): React.JSX.Element => {
  const { size } = React.useContext(SegmentedControlContext)

  return <StyledText {...props} size={size} />
}
